import { render, staticRenderFns } from "./tableEditor.vue?vue&type=template&id=6e1528ac"
import script from "./tableEditor.vue?vue&type=script&lang=js"
export * from "./tableEditor.vue?vue&type=script&lang=js"
import style0 from "./tableEditor.vue?vue&type=style&index=0&id=6e1528ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports